(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = [...document.querySelectorAll('[data-bas-scroll-scene]')];
  let scheduled = false;
  const update = () => {
    scheduled = false;
    scenes.forEach(scene => {
      const box = scene.getBoundingClientRect();
      const distance = Math.max(1, scene.offsetHeight - innerHeight);
      const progress = motion.matches ? 0 : Math.min(1, Math.max(0, -box.top / distance));
      scene.style.setProperty('--scene-progress', progress.toFixed(4));
    });
  };
  const requestUpdate = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  addEventListener('scroll', requestUpdate, { passive: true });
  addEventListener('resize', requestUpdate, { passive: true });
  motion.addEventListener('change', requestUpdate);
  update();
  const cards = document.querySelectorAll('.bas-ui .scp-photo-story__card');
  if ('IntersectionObserver' in window && !motion.matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      entry.target.classList.toggle('bas-detail-active', entry.isIntersecting);
    }), { threshold: 0.4 });
    cards.forEach(card => observer.observe(card));
  }
})();
